import { proxy, ref } from "valtio";

const storeModel = {
  currentRail: 0,
};

export const powerrailstore = proxy(storeModel);
